// extracted by mini-css-extract-plugin
export default {"storyboard":"storyboard__+gWJR"};